import { render } from "./recommend-param.vue?vue&type=template&id=00d01e7b&scoped=true"
import script from "./recommend-param.vue?vue&type=script&lang=js"
export * from "./recommend-param.vue?vue&type=script&lang=js"

import "./recommend-param.vue?vue&type=style&index=0&id=00d01e7b&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d01e7b"]])

export default __exports__